import { isServer } from '..';
export function isAndroid() {
  /* istanbul ignore next */
  return isServer ? false : /android/.test(navigator.userAgent.toLowerCase());
}
export function isIOS() {
  /* istanbul ignore next */
  return isServer ? false : /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/utils/validate/system.js
// module id = 233
// module chunks = 74